interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'primary';
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = '確認',
  cancelText = '取消',
  variant = 'primary',
  isLoading = false,
  onConfirm,
  onCancel
}: ConfirmModalProps) {
  if (!isOpen) return null;

  const buttonClass = {
    danger: 'btn-destructive',
    warning: 'btn-warning',
    primary: 'btn-primary'
  }[variant];

  return (
    <div className="modal">
      <div className="overlay" onClick={isLoading ? undefined : onCancel} />
      <div className="modal-content max-w-md">
        <div className="card-header">
          <h3 className="heading-section">{title}</h3>
        </div>
        <div className="card-body">
          <p className="body-base">{message}</p>
        </div>
        <div className="card-footer flex justify-end gap-3">
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="btn btn-ghost btn-md"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className={`btn ${buttonClass} btn-md`}
          >
            {isLoading ? (
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                處理中...
              </span>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
